import { UPDATE_BREAKPOINT } from '@/store/constants'

export const namespaced = true

export const state = {
  breakpoint: '',
  height: null,
  width: null
}

export const actions = {
  updateBreakpoint({ commit }, sizeInfo) {
    commit(UPDATE_BREAKPOINT, sizeInfo)
  }
}

export const getters = {
  breakpoint: state => state.breakpoint,
  height: state => state.height,
  width: state => state.width,
  isMobile: state => state.breakpoint === 'xs'
}

export const mutations = {
  [UPDATE_BREAKPOINT]: (state, { height, width }) => {
    state.height = height
    state.width = width

    if (width >= 1280) {
      state.breakpoint = 'xl'
    } else if (width >= 1024) {
      state.breakpoint = 'lg'
    } else if (width >= 768) {
      state.breakpoint = 'md'
    } else if (width >= 640) {
      state.breakpoint = 'sm'
    } else {
      state.breakpoint = 'xs'
    }
  }
}
